import React from "react";
import Hero from "@/components/sections/Hero";
import CategoriesGrid from "@/components/sections/CategoriesGrid";
import StoryPreview from "@/components/sections/StoryPreview";
import ToolsPreview from "@/components/sections/ToolsPreview";
import TrustBar from "@/components/sections/TrustBar";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import CTABand from "@/components/sections/CTABand";

const Home = () => {
  return (
    <main>
      <Hero />
      <TrustBar />
      <CategoriesGrid />
      <StoryPreview />
      <ToolsPreview />
      <Testimonials />
      <FAQ />
      <CTABand />
    </main>
  );
};

export default Home;
